// Copyright (c) 2020 Deere & Company

import Report, {getDefaultState} from '../state/report';
import actions from '../../actions-list';

const updatePartCoverageSearchReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

const resetToDefaultState = () => getDefaultState();

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_PART_COVERAGE_SEARCH_REPORT_SUCCESS]: updatePartCoverageSearchReport,
        [actions.RESET_PART_COVERAGE_SEARCH_REPORT]: resetToDefaultState
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/reducers/report.js